import DOMPurify from 'dompurify';

/** Keep in sync with [supabase/functions/_shared/email_sanitize.ts](supabase/functions/_shared/email_sanitize.ts) */
export const EMAIL_HTML_ALLOWED_TAGS = [
  'p',
  'br',
  'strong',
  'em',
  'b',
  'i',
  'u',
  'a',
  'ul',
  'ol',
  'li',
  'h1',
  'h2',
  'h3',
  'span',
  'div',
  'img',
  'table',
  'thead',
  'tbody',
  'tr',
  'th',
  'td',
  'hr',
  'blockquote',
];

export const EMAIL_HTML_ALLOWED_ATTR = [
  'href',
  'target',
  'rel',
  'src',
  'alt',
  'width',
  'height',
  'class',
  'colspan',
  'rowspan',
  'style',
];

export function sanitizeEmailHtml(dirty: string): string {
  return DOMPurify.sanitize(dirty, {
    ALLOWED_TAGS: EMAIL_HTML_ALLOWED_TAGS,
    ALLOWED_ATTR: EMAIL_HTML_ALLOWED_ATTR,
    ALLOW_DATA_ATTR: false,
    ADD_ATTR: ['target'],
  });
}

/** Strip HTML for multipart/plain fallback (after variable substitution). */
export function htmlToPlainTextEmail(html: string): string {
  if (!html?.trim()) return '';
  let t = html.replace(/<br\s*\/?>/gi, '\n');
  t = t.replace(/<\/(p|div|h[1-6]|tr)>/gi, '\n');
  t = t.replace(/<li>/gi, '• ');
  t = t.replace(/<[^>]+>/g, '');
  t = t
    .replace(/&nbsp;/g, ' ')
    .replace(/&amp;/g, '&')
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&quot;/g, '"');
  t = t.replace(/\n{3,}/g, '\n\n').trim();
  return t;
}
